// extracted by css-extract-rspack-plugin
export default {"root":"root-SS7oTz","bundleViewer":"bundleViewer-_WbWUr text-base"};